export default __webpack_public_path__ + "static/media/pic8.7010d3b7.jpg";